// src/modules/app-views/products/config.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************

import ProductsInit from './pages/Init';
import ListProvider from 'components/core/ListProvider';
import { API } from 'constants/Api';
import productsInitActionButton from 'modules/app-views/products/pages/Init/actions/actionButton';
import productsInitMenuButton from 'modules/app-views/products/pages/Init/actions/menuButton';
import DocumentProvider from 'components/core/DocumentProvider';
import useZustand from 'hooks/useZustand';
import CardHeaderTitle from 'layouts/Pages/PageHeader/CardHeaderTitle';
import ProductsDocument from 'modules/app-views/products/pages/Document';
import productsDocumentActionButton from 'modules/app-views/products/pages/Document/actions/actionButton';
import productsDocumentMenuButton from 'modules/app-views/products/pages/Document/actions/menuButton';
import ProductsParametersModal from 'modules/app-views/products/pages/Init/modals/ProductsParametersModal';
import seedProductsParameters from 'modules/app-views/products/seed';
import productsDocumentDecorateRequest from './pages/Document/decorators/request';
import ProductsAi from 'modules/app-views/products/pages/Ai';
import aiGenerativeIcon from 'assets/images/ai-generative.png';
import ProductsDocumentCardHeaderColumn2 from 'modules/app-views/products/pages/Document/components/ProductsDocumentCardHeaderColumn2';
import ProductsDocumentCardHeaderColumn3 from 'modules/app-views/products/pages/Document/components/ProductsDocumentCardHeaderColumn3';
import CardHeaderProductTags from 'modules/app-views/products/pages/Document/components/CardHeaderProductTags';
import CardHeaderProductIcons from 'modules/app-views/products/pages/Document/components/CardHeaderProductIcons';
import authService from 'services/authService';
import CardHeaderColumn from 'layouts/Pages/PageHeader/CardHeaderColumn';
import { createdAtItem, documentCodeItem, updatedAtItem } from 'layouts/Pages/PageHeader/CardHeaderColumn/items';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************
const MODULE_ID = 'products';

// *******************************************************************************
// PRE CONFIG
// *******************************************************************************
const preConfigChanges = appId => {
  CONFIG.appId = appId;
};

// *******************************************************************************
// MODULE CONFIGURATION
// *******************************************************************************
const CONFIG = {
  version: 2,
  id: MODULE_ID,
  initialPage: 'init',
  initialParams: {},
  initialQuery: {},
  parametersModalComponent: ProductsParametersModal,
  parametersSeed: seedProductsParameters,

  // ───────────────────────────────────────────────────────────────────────
  // MIGRATORY
  // ───────────────────────────────────────────────────────────────────────
  migratory: {
    title: 'products_migration',
    schema: [],
  },
};

// *******************************************************************************
// MODULE PAGES
// *******************************************************************************
const PAGES = {
  init: {
    // ───────────────────────────────────────────────────────────────────────
    // PAGE CORE
    // ───────────────────────────────────────────────────────────────────────
    layout: 'list', // 'page' | 'list' | 'document'
    moduleId: MODULE_ID,
    component: props => (
      <ListProvider {...props}>
        <ProductsInit />
      </ListProvider>
    ),

    // ───────────────────────────────────────────────────────────────────────
    // TOUR
    // ───────────────────────────────────────────────────────────────────────
    tour: {
      firstModal: null,
      lastModal: null,
      onFinish: null,
      triggerConfettiOnFinish: false,
      videoLink: {
        br: null,
        us: null,
      },
    },

    // ───────────────────────────────────────────────────────────────────────
    // API & DATA
    // ───────────────────────────────────────────────────────────────────────
    api: {
      url: API.PRODUCTS.PAGINATION,
      params: null,
      query: null,

      // data transformation
      returnAsObject: false,

      // initial configuration
      autoFetch: true,
      fetchWithoutSubscription: false,
      removeSubscriptionIdFromHeader: false,
      persistInStore: true,
    },

    // ───────────────────────────────────────────────────────────────────────
    // DECORATORS
    // ───────────────────────────────────────────────────────────────────────
    decorators: {
      request: null,
      responseDoc: null,
      responseData: null,
      // responseData: data => {
      //   const storedParameters = useZustand('app', 'parameters', false);
      //   const brands = storedParameters?.modules?.products?.brands || [];
      //   const units = storedParameters?.modules?.products?.units || [];
      //   const categories = storedParameters?.modules?.products?.categories || [];
      //
      //   // Build Sets for fast lookup
      //   const paramBrandUids = new Set(brands.map(b => b.uid));
      //   const paramUnitUids = new Set(units.map(u => u.uid));
      //
      //   // Recursively extract all category UIDs (tree structure with children)
      //   const paramCategoryUids = new Set();
      //   const extractCategoryUids = items => {
      //     items.forEach(item => {
      //       if (item.uid) paramCategoryUids.add(item.uid);
      //       if (Array.isArray(item.children) && item.children.length > 0) {
      //         extractCategoryUids(item.children);
      //       }
      //     });
      //   };
      //   extractCategoryUids(categories);
      //
      //   // Check each product for missing references
      //   const missingRefs = [];
      //   data.forEach(product => {
      //     const missing = { _id: product._id, name: product.name, issues: [] };
      //
      //     // Check brandUid
      //     if (product.brandUid && !paramBrandUids.has(product.brandUid)) {
      //       missing.issues.push({ field: 'brandUid', value: product.brandUid });
      //     }
      //
      //     // Check unitUid
      //     if (product.unitUid && !paramUnitUids.has(product.unitUid)) {
      //       missing.issues.push({ field: 'unitUid', value: product.unitUid });
      //     }
      //
      //     // Check categoryUids (array)
      //     if (Array.isArray(product.categoryUids)) {
      //       product.categoryUids.forEach(catUid => {
      //         if (catUid && !paramCategoryUids.has(catUid)) {
      //           missing.issues.push({ field: 'categoryUids', value: catUid });
      //         }
      //       });
      //     }
      //
      //     if (missing.issues.length > 0) {
      //       missingRefs.push(missing);
      //     }
      //   });
      //
      //   const notExists = missingRefs.length > 0;
      //
      //   if (notExists) {
      //     console.warn('⚠️ Products with missing parameter references:', missingRefs);
      //     // TODO: Handle missing references (show notification, mark products, etc.)
      //     authService.signInRefresh().then();
      //   } else {
      //     console.log('tudo certo!');
      //   }
      //
      //   return data;
      // },
    },

    // ───────────────────────────────────────────────────────────────────────
    // ROUTING & NAVIGATION
    // ───────────────────────────────────────────────────────────────────────
    routing: {
      endpoint: null,
      paramKey: null,
      query: null,
    },

    // ───────────────────────────────────────────────────────────────────────
    // LIST PROVIDER ONLY - PAGINATION CONFIGURATION
    // ───────────────────────────────────────────────────────────────────────
    pagination: {
      pagination: { page: 1, size: 10 },
      sort: [
        { field: '_metadata.audit.updatedAt', order: 'desc', index: 1 },
        // { field: 'description', order: 'asc', index: 1 },
      ],
      search: {},
      textSearch: '',
      filter: {},
      drawer: { folder: 'inbox' },
    },

    // ───────────────────────────────────────────────────────────────────────
    // LIST PROVIDER ONLY - TABLE SETTINGS
    // ───────────────────────────────────────────────────────────────────────
    table: {
      actions: ['edit', 'archive', 'remove'],
      hiddenColumns: ['line', 'documentCode', 'ean', 'ncm', 'status', 'createdAt'],
    },

    // ───────────────────────────────────────────────────────────────────────
    // DOCUMENT PROVIDER ONLY - PAGE SETTINGS
    // ───────────────────────────────────────────────────────────────────────
    settings: null,

    // ───────────────────────────────────────────────────────────────────────
    // HEADER CONFIGURATION
    // ───────────────────────────────────────────────────────────────────────
    header: {
      visible: true,
      style: 'default', // 'default' | 'card'
      actions: ['filter', 'refresh', productsInitActionButton, productsInitMenuButton],

      navigation: {
        showTitle: true,
        showBreadcrumb: true,
      },
    },
  },

  ai: {
    highSecurity: false,

    // ───────────────────────────────────────────────────────────────────────
    // PAGE CORE
    // ───────────────────────────────────────────────────────────────────────
    layout: 'page',
    moduleId: MODULE_ID,
    component: props => (
      <DocumentProvider {...props} hideBackToHomeLink={true}>
        <ProductsAi />
      </DocumentProvider>
    ),

    // ───────────────────────────────────────────────────────────────────────
    // TOUR
    // ───────────────────────────────────────────────────────────────────────
    tour: {
      firstModal: null,
      lastModal: null,
      onFinish: null,
      triggerConfettiOnFinish: false,
      videoLink: {
        br: null,
        us: null,
      },
    },

    // ───────────────────────────────────────────────────────────────────────
    // API & DATA
    // ───────────────────────────────────────────────────────────────────────
    api: {
      url: null,
      params: null,
      query: null,

      // data transformation
      returnAsObject: true,

      // initial configuration
      autoFetch: false,
      fetchWithoutSubscription: false,
      removeSubscriptionIdFromHeader: false,
      persistInStore: false,
    },

    // ───────────────────────────────────────────────────────────────────────
    // DECORATORS
    // ───────────────────────────────────────────────────────────────────────
    decorators: {
      request: null,
      response: null,
    },

    // ───────────────────────────────────────────────────────────────────────
    // ROUTING & NAVIGATION
    // ───────────────────────────────────────────────────────────────────────
    routing: {
      endpoint: '/ai',
      paramKey: null,
      query: null,
    },

    // ───────────────────────────────────────────────────────────────────────
    // LIST PROVIDER ONLY - PAGINATION CONFIGURATION
    // ───────────────────────────────────────────────────────────────────────
    pagination: null,

    // ───────────────────────────────────────────────────────────────────────
    // LIST PROVIDER ONLY - TABLE SETTINGS
    // ───────────────────────────────────────────────────────────────────────
    table: null,

    // ───────────────────────────────────────────────────────────────────────
    // DOCUMENT PROVIDER ONLY - PAGE SETTINGS
    // ───────────────────────────────────────────────────────────────────────
    settings: {
      // initialTab: 'record',
      // initialValues: {},
      // actions: [
      //   'editRefresh',
      //   productsDocumentActionButton(),
      //   productsDocumentDropdownMenu(),
      //   'return',
      // ],
      // viewMode: 'auto',
    },

    // ───────────────────────────────────────────────────────────────────────
    // HEADER CONFIGURATION
    // ───────────────────────────────────────────────────────────────────────
    header: {
      visible: true,
      style: 'card', // 'default' | 'card'

      avatar: {
        visible: true,
      },

      navigation: {
        showTitle: true,
        showBreadcrumb: true,
        showHighlightTitle: 'new_product',
        showHighlightIcon: aiGenerativeIcon,
      },

      card: {
        title: () => null,
        subtitle: () => null,
        column1: () => null,
        column2: () => null,
      },
    },
  },

  document: {
    highSecurity: false,

    // ───────────────────────────────────────────────────────────────────────
    // PAGE CORE
    // ───────────────────────────────────────────────────────────────────────
    layout: 'document',
    moduleId: MODULE_ID,
    component: props => (
      <DocumentProvider {...props}>
        <ProductsDocument />
      </DocumentProvider>
    ),

    // ───────────────────────────────────────────────────────────────────────
    // TOUR
    // ───────────────────────────────────────────────────────────────────────
    tour: {
      firstModal: null,
      lastModal: null,
      onFinish: null,
      triggerConfettiOnFinish: false,
      videoLink: {
        br: null,
        us: null,
      },
    },

    // ───────────────────────────────────────────────────────────────────────
    // API & DATA
    // ───────────────────────────────────────────────────────────────────────
    api: {
      url: API.PRODUCTS.URL,
      params: null,
      query: null,

      // data transformation
      returnAsObject: true,

      // initial configuration
      autoFetch: true,
      fetchWithoutSubscription: false,
      removeSubscriptionIdFromHeader: false,
      persistInStore: true,
    },

    // ───────────────────────────────────────────────────────────────────────
    // DECORATORS
    // ───────────────────────────────────────────────────────────────────────
    decorators: {
      request: productsDocumentDecorateRequest,
      response: null,
    },

    // ───────────────────────────────────────────────────────────────────────
    // ROUTING & NAVIGATION
    // ───────────────────────────────────────────────────────────────────────
    routing: {
      endpoint: '/:_id',
      paramKey: '_id',
      query: null,
    },

    // ───────────────────────────────────────────────────────────────────────
    // LIST PROVIDER ONLY - PAGINATION CONFIGURATION
    // ───────────────────────────────────────────────────────────────────────
    pagination: null,

    // ───────────────────────────────────────────────────────────────────────
    // LIST PROVIDER ONLY - TABLE SETTINGS
    // ───────────────────────────────────────────────────────────────────────
    table: null,

    // ───────────────────────────────────────────────────────────────────────
    // DOCUMENT PROVIDER ONLY - PAGE SETTINGS
    // ───────────────────────────────────────────────────────────────────────
    settings: {
      initialTab: 'record',
      initialValues: {
        stock: {
          purpose: 'resale',
          tracking: 'none',
          isUnique: false,
          variantMode: 'none',
          channels: ['store'],
          trackInventory: true,
          allowNegativeStock: false,
        },
      },
      actions: [
        'editRefresh',
        productsDocumentActionButton(),
        productsDocumentMenuButton(),
        'return',
      ],
      viewMode: 'auto',
      backPage: 'init',
    },

    // ───────────────────────────────────────────────────────────────────────
    // HEADER CONFIGURATION
    // ───────────────────────────────────────────────────────────────────────
    header: {
      visible: true,
      style: 'card', // 'default' | 'card'

      avatar: {
        visible: true,
        placeholder: 'product',
      },

      navigation: {
        showTitle: true,
        showBreadcrumb: true,
      },

      card: {
        title: props => {
          const sku = props?.sku;
          const name = props?.name;
          const display = sku ? `${sku} - ${name}` : name;
          return <CardHeaderTitle {...props} name={display?.toUpperCase()} />;
        },
        subtitle: props => {
          const suppliers = props?.suppliers || [];
          const primary = suppliers.find(s => s.isPrimary && s.isActive !== false)
            || suppliers.find(s => s.isActive !== false)
            || suppliers[0];
          const supplierName = primary?.__entity?.name || primary?.supplierName || '';
          return supplierName
            ? <span className="text-muted">{supplierName}</span>
            : null;
        },

        column1: props => (
          <CardHeaderColumn {...props} items={[documentCodeItem, createdAtItem, updatedAtItem]} />
        ),

        column2: props => <ProductsDocumentCardHeaderColumn2 {...props} />,
        column3: props => <ProductsDocumentCardHeaderColumn3 {...props} />,

        tags: props => <CardHeaderProductTags data={props} />,
        icons: (data, countryCode) => <CardHeaderProductIcons data={data} />,
      },
    },
  },
};

// *******************************************************************************
// MOCK DATA
// *******************************************************************************
const MOCK = {
  document: {
    name: 'lampada X',
    unitUid: '6954679dca33ae2a4d21009f',
    price: 34.66,
    description: '110v',
    brandUid: '69546875d9a60a3a775a552b',
    category: ['6954eb23523758622645568f', '6954eb30e6e3431c10ea7d5e', '6954eb35b8ca7fe6b1fc7b78'],
    ean: '123123',
    backColor: '#FFFFFF',
    foreColor: '#000000',
  },
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default { CONFIG, PAGES, MOCK, preConfigChanges };
